module.exports = __webpack_public_path__ + "static/media/bulk7.ab06c27f.png";